import { AbstractControl } from '@angular/forms';

import { regexList } from './regex-list';

// eslint-disable-next-line complexity
export function UsernameSkyMilesNumberEmailValidator(
  control: AbstractControl
): {
  [s: string]: boolean;
} {
  const value = control?.value?.value.trim();
  if (value?.match(regexList.userIdLength)) {
    if (value.match(regexList.skyMilesNumber)) {
      return <{ [s: string]: boolean }>(<unknown>null);
    } else if (
      value.match(regexList.userName) &&
      value.match(regexList.isNaN)
    ) {
      return <{ [s: string]: boolean }>(<unknown>null);
    } else if (value.match(regexList.email)) {
      return <{ [s: string]: boolean }>(<unknown>null);
    }
  }
  return { INVALID_SKYMILES_NUMBER: true };
}

export function SkyMilesNumberValidator(control: AbstractControl): {
  [s: string]: boolean;
} {
  const value = control?.value?.value.trim();
  if (value?.match(regexList.userIdLength)) {
    if (value.match(regexList.skyMilesNumber)) {
      return <{ [s: string]: boolean }>(<unknown>null);
    }
  }
  return { INVALID_SKYMILES_NUMBER: true };
}

export function FirstNameValidator(control: AbstractControl): {
  [s: string]: boolean;
} {
  const value = control?.value?.value.trim();
  if (
    value?.match(regexList.firstNameLength) &&
    value.match(regexList.firstName)
  ) {
    return <{ [s: string]: boolean }>(<unknown>null);
  }
  return { FIRSTNAME_NO_MATCH: true };
}

export function LastNameValidator(control: AbstractControl): {
  [s: string]: boolean;
} {
  const value = control?.value?.value.trim();
  if (
    value?.match(regexList.lastNameLength) &&
    value.match(regexList.lastName)
  ) {
    return <{ [s: string]: boolean }>(<unknown>null);
  }
  return { INVALID_LASTNAME: true };
}
